import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestNews from './components/LatestNews';
import HotCategories from './components/HotCategories';
import ScandalTracker from './components/ScandalTracker';
import TrendingSidebar from './components/TrendingSidebar';
import NewsletterForm from '@/components/base/NewsletterForm';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function Home() {
  const recentArticles = articles.slice(3, 7);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '吃瓜官网',
    url: 'http://dollydiy.cn/',
    description: '吃瓜官网作为全网核心吃瓜入口，覆盖51吃瓜官网全网最新、黑料吃瓜官网等热门站点，每日推送独家大瓜与网红翻车现场实时追踪。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://dollydiy.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吃瓜官网',
    url: 'http://dollydiy.cn/',
    description: '全网最全吃瓜入口',
    email: 'hello@dollydiy.cn',
    foundingDate: '2024',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />

          <div className="mx-auto px-4 md:px-6 max-w-7xl">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1 min-w-0">
                <div className="py-10 md:py-14">
                  <LatestNews />
                </div>
              </div>
              <div className="w-full lg:w-[320px] flex-shrink-0 pt-10 md:pt-14">
                <TrendingSidebar />
              </div>
            </div>
          </div>

          <HotCategories />

          <section className="mx-auto px-4 md:px-6 max-w-7xl py-10 md:py-14">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
                  黑料深度爆料
                </h2>
                <p className="text-foreground-500 text-sm mt-1">独家内幕，深度挖掘</p>
              </div>
              <Link to="/category/heila-baoliao" className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">
                更多黑料 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {recentArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          <ScandalTracker />

          <NewsletterForm />
        </main>

        <Footer />
      </div>
    </>
  );
}